import React from "react";
import "./style.css";
import { Container } from "@material-ui/core";
import { Menu } from "@material-ui/icons";
import { NavLink } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Search } from "@material-ui/icons";
const useStyles = makeStyles((theme) => ({
  input: {
    width: "100%",
    height: 30,
    marginTop:'5px',
    fontSize: "14px",
    background: "white",
  },
}));
export default function Header() {
  const classes = useStyles();
  return (
    <Container>
      <nav>
        <h2 id="logo">Versus</h2>
        <label for="drop" class="toggle">
          <Menu />
        </label>
        <input type="checkbox" id="drop" />
        <ul class="menu">
          <li>
            <NavLink to="/">HOME</NavLink>
          </li>
          <li>
            <label for="drop-2" class="toggle">
              CATEGORIES +
            </label>
            <a href="#">CATEGORIES</a>
            <input type="checkbox" id="drop-2" />
            <ul>
              <li>
                <a href="#">Resources 1</a>
              </li>
              <li>
                <a href="#">Resources 2</a>
              </li>
              <li>
                <label for="drop-3" class="toggle">
                  Tutorials +
                </label>
                <a href="#">Tutorials</a>
                <input type="checkbox" id="drop-3" />

                <ul>
                  <li>
                    <a href="#">HTML/CSS</a>
                  </li>
                  <li>
                    <a href="#">jQuery</a>
                  </li>
                  <li>
                    <a href="#">Other</a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li id="seach-bar">
            <OutlinedInput
              id="outlined-adornment-password"
              type="text"
              name="text"
              placeholder="Search"
              className={`${classes.input}`}
              endAdornment={
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              }
              labelWidth={0}
            />
          </li>
          <li>
            <NavLink to="/compare/smartphones">SMARTPHONES</NavLink>
          </li>
          <li>
            <NavLink to="/compare/smartwatches">SMARTWATCHES</NavLink>
          </li>
          <li>
            <NavLink to="/compare/headphones">HEADPHONES</NavLink>
          </li>
          <li>
            <NavLink to="/compare/tablets">TABLETS</NavLink>
          </li>
        </ul>
      </nav>
    </Container>
  );
}
